<template>
    <div>
        <modal-home :title="'Grind Confirmation'" :show-close-btn="true" ref="modal">
            <slot slot-scope="modal">
                <div class="confirmation-modal align-center padded margin-top-md pb-5"> 
                    <p>You have selected <b>"{{ humanizeGrind(grind, true) }}"</b> for this coffee. However, the selected grind setting in your suggested Brew Queue's filter is <b>"{{ humanizeGrind(brewgrind, true) }}"</b>.</p>
                    <p>Are you sure you want to add this to your brew queue?</p>

                    <div class="flex items-center justify-center">
                        <button @click="grindConfirmed()" class="order-history-btn confirm-btn-yes mt-3 mb-6">Yes</button>
                        <button @click="modal.close" class="order-history-btn confirm-btn-no mt-3 mb-6">No</button>
                    </div>
                    <i>If you want to stop this pop up alert you can update your preferred Grind settings, to match, in your Suggested Brew Queue filters. Just open your Brew Queue and click the Equalizer icon at the top of the Suggested coffee list (usually about half way down, after your main brew queue of coffees you add) to make any changes you'd like.</i>
                </div>
            </slot>
        </modal-home>
    </div>
</template>

<script>
    import ModalHome from './modal-home';
    import CoffeeMixin from '../../mixins/coffee-mixin';

    export default {
        components: {
            ModalHome
        },
        mixins: [
            CoffeeMixin
        ],
        props: {
            grind: String,
            // brewGrind: Object
        },
        data: function() {
            return  {
                brewgrind: undefined
            }
        },
        methods: {
            show(bgrind) {
                this.brewgrind = bgrind;
                this.$refs.modal.show();
            },
            close() {
                this.$refs.modal.close();
            },
            grindConfirmed() {
                this.$emit('confirmed');
                this.close();
            }
        },
    }
</script>

<style lang="scss" scoped>
    @import "../../styles/_variables_home.scss";
    @import "../../styles/common_home.scss";

    .confirm-btn-yes {
        color: $green-primary;
        background-color: $white;
        border: solid 1px $green-primary;
        border-radius: 50px;
        padding: .25rem 2rem;
        margin: 1rem 1rem 2rem 1rem;
        @include btn-transparent-effect($green-primary);
    }
    .confirm-btn-no {
        @extend .confirm-btn-yes;
        color: $red;
        border-color: $red;
        @include btn-transparent-effect($red);
    }
</style>
